import * as React from "react";
import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

import {CSSTransition, TransitionGroup} from "react-transition-group";
import {ColorLineScroller} from "./color-line-scroller";
import "./color-tiles.scss";

export const rColorLineTiles = (cc, build3=false) =>
    <div className="color-tiles-4ux">
        {cs(
            ["currentColor", (_, next) => UseState({
                initValue: build3? Object.keys(cc.colorSet?.value)[cc.selected ? cc.selected-1 : 0] : cc.inputData?.colorSet
                ? cc.inputData.colorSet
                : cc.ccConfig.colorSet
                    ? Object.keys(cc.ccConfig.colorSet)[0]
                    : '',
                next,
            })],
            (_, next) => <ColorLineScroller {...{next}}/>,
            ({currentColor}) => (
                <div
                    className="boxes"
                >
                    {(() => {
                        return cs(
                            ["child", ({}, next) => Object.entries( build3 ? cc.colorSet?.value : cc.ccConfig.colorSet).map(([setName, colors], i) => next({setName, colors, i}))],
                            ({child}, next) => <CssTransition {...{
                                key: child['setName'],
                                classNames: "from-right",
                                next,
                            }}/>,
                            ({child}) => {
                                let rgbHex = `#${child['colors'][0]['rgbHex']}`;
                                return <div
                                    className="box"
                                    key={child['setName']}
                                    onClick={() => {
                                        currentColor.onChange(child['setName']);
                                        !build3 && cc.applyTheme(child['setName'], true);
                                    }}
                                    style={{
                                        backgroundColor: rgbHex, border: `2px solid ${(currentColor.value === child['setName'] ? '#FF9800': rgbHex)}`,
                                        color: getContrastYIQ(rgbHex)
                                    }}
                                    xd-qa-type="button"
                                    xd-qa-name={child['colors'][0]['name']}
                                >
                                    {child['colors'][0]['name']}
                                </div>
                            }
                        );
                    })()}
                    {build3 ? <input name="color_field_1" value={cc.colorSet.value[currentColor.value]?.[0]['idSet']} onChange={() => false} hidden/> : ''}
                    {build3 ? <input name="color_field_2" value={Object.keys(cc.colorSet.value).indexOf(currentColor.value)+1} onChange={() => false} hidden/> : ''}
                </div>
            )
        )}
    </div>;

const CssTransition = (
    {next, classNames} : {
        next: () => JSX.Element,
        classNames: string,
    }
) => (
    <TransitionGroup appear>
        <CSSTransition timeout={3000} classNames={classNames} appear>
            {next()}
        </CSSTransition>
    </TransitionGroup>
);

/*Selects black or white text color for maximum
    contrast with the provided background color */
const  getContrastYIQ =( hexcolor ) => {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexcolor);
    if(!result || result.length < 4) return null;
    let r = parseInt(result[1], 16);
    let g = parseInt(result[2], 16);
    let b = parseInt(result[3], 16);

    let yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    return (yiq >= 128) ? '#000' : '#fff';
};